import axios from 'axios';

import { getDevPortalBaseUrl } from '../../utils/environment';

const DEFAULT_API_TIMEOUT = 3000;

export const devPortalAxiosClient = axios.create({
  baseURL: getDevPortalBaseUrl(),
  timeout: DEFAULT_API_TIMEOUT,
  withCredentials: true,
  transitional: {
    clarifyTimeoutError: true,
  },
});
